import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "product-content",
  class ProductContent extends WYATTElement {
    connectedCallback() {
      this.sections = [];
      this.handle = this.dataset.productContent;
      this.relatedContentTemplate = document.querySelector(
        `#related-content-${this.handle}`,
      );

      this.parseSections();
      this.buildUI();
    }

    buildUI() {
      const placeholders = this.querySelectorAll(
        "[data-product-content-placeholder]",
      );

      placeholders.forEach(this.injectHTML.bind(this));
    }

    injectHTML(placeholder) {
      const componentType = placeholder.dataset.productContentPlaceholder;
      let componentHTML;

      switch (componentType) {
        case "tabs":
          componentHTML = this.getTabsHTML();
          break;
        case "accordion":
          componentHTML = this.getAccordionHTML();
          break;
        default:
      }

      placeholder.innerHTML = componentHTML;
    }

    getAccordionHTML() {
      const buttonPanel = (section) => {
        const heading = section.heading.textContent.replace(":", "");
        const shouldRenderRelatedContent =
          this.relatedContentTemplate && heading === "Related Content";
        let content = section.body
          .map((element) => element.outerHTML || element.textContent)
          .join("");

        if (shouldRenderRelatedContent) {
          content = this.relatedContentTemplate.innerHTML;
        }

        return `
          <details class="accordion__details">
            <summary class="accordion__heading">
              <span class="accordion__heading-text heading-3">${heading}</span>
              <span class="accordion__heading-icon">
                <span class="icon accordion__icon" aria-hidden="true" focusable="false" role="presentation">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 11 6"
                    width="11"
                    height="6"
                    fill="currentColor"
                  >
                    <path
                      d="M0.176743 0.275467C0.0503609 0.401731 -0.0206299 0.572958 -0.0206299 0.751572C-0.0206299 0.930174 0.0503609 1.10147 0.176743 1.22765L4.74745 5.80196C4.87372 5.92834 5.04493 5.99934 5.22354 5.99934C5.40215 5.99934 5.57336 5.92834 5.69962 5.80196L10.2703 1.22765C10.4018 1.10255 10.4771 0.929722 10.4794 0.748306C10.4814 0.56677 10.4102 0.392146 10.2818 0.263992C10.1533 0.135851 9.9786 0.064878 9.79718 0.0674591C9.61576 0.0699229 9.44303 0.145483 9.31818 0.277145L5.22363 4.37532L1.12907 0.277145C1.00304 0.150647 0.83194 0.0792885 0.653336 0.0789337C0.474734 0.0786996 0.303124 0.14932 0.176743 0.275467Z"
                      fill="black"
                    />
                  </svg>
                </span>
              </span>
            </summary>
            <div class="accordion__panel">
              ${content}
            </div>
          </details>
        `;
      };

      return `
        <div class="accordion">
          ${this.sections.map(buttonPanel).join("")}
        </div>
      `;
    }

    getTabsHTML() {
      const button = (section) => {
        const text = section.heading.textContent.replace(":", "");

        return `
          <button type="button" class="tabs__trigger button-reset">
            <span class="tabs__trigger-text">${text}</span>
          </button>
        `;
      };

      const panel = (section) => {
        const elements = section.body;
        const text = section.heading.textContent.replace(":", "");
        const shouldRenderRelatedContent =
          this.relatedContentTemplate && text === "Related Content";
        let content = elements
          .map((element) => element.outerHTML || element.textContent)
          .join("");

        if (shouldRenderRelatedContent) {
          content = this.relatedContentTemplate.innerHTML;
        }

        return `
          <div class="tabs__panel">
            ${content}
          </div>
        `;
      };

      return `
        <wyatt-tabs class="tabs">
          <div class="tabs__triggers">
            ${this.sections.map(button).join("")}
          </div>
          <div class="tabs__panels">
            ${this.sections.map(panel).join("")}
          </div>
        </wyatt-tabs>
      `;
    }

    parseSections() {
      const { description } = WYATT.shopify.product[this.handle];

      const DOM = new DOMParser().parseFromString(description, "text/html");

      this.addHeadings(DOM);
      this.addBodyElements(DOM);
    }

    addHeadings(DOM) {
      const headings = DOM.querySelectorAll("h3");

      headings.forEach((heading) => {
        this.sections.push({
          heading,
          body: [],
        });
      });
    }

    addBodyElements(DOM) {
      const children = DOM.body.childNodes;
      let currentSection;

      children.forEach((node) => {
        const newSection = node.nodeName === "H3";

        if (newSection) {
          currentSection = this.sections.find(
            ({ heading }) => heading === node,
          );
        } else if (currentSection) {
          currentSection.body.push(node);
        }
      });
    }
  },
);
